import type { EventParams } from 'types/common';
import { CategoryEnum, CustomerTypeEnum, IdTypeEnum } from 'types/customer';
import { isEmptyValue } from 'utils/helper';

/**
 * @description 根据传入的参数, 判断需要上传埋点系统的开户类型, 即埋点系统中的parma1字段
 * @param params 判断依赖的参数
 */
export function getTrackOpenType(params: { idType?: IdTypeEnum; category?: CategoryEnum }): EventParams['openType'] {
    const { category, idType } = params;
    let trackOpenType: EventParams['openType'];

    if (idType) {
        if (idType === IdTypeEnum.SSN_IDS) {
            trackOpenType = 'ssn';

            if (category === CategoryEnum.IRA) {
                trackOpenType = 'ira';
            }
        } else {
            trackOpenType = 'no_ssn';
        }
    }

    return trackOpenType;
}

export function getTrackEventBaseInfoType(params: {
    idType?: IdTypeEnum;
    customerType?: CustomerTypeEnum;
    // 是有有美国邮寄地址
    hasDeliveryAddress?: boolean;
}): string | undefined {
    const { customerType, hasDeliveryAddress, idType } = params;
    let eventBaseInfoType: string | undefined;

    if (idType) {
        if (idType === IdTypeEnum.SSN_IDS) {
            switch (customerType) {
                case CustomerTypeEnum.IRA_ROTH:
                    eventBaseInfoType = 'roth_ira';
                    break;
                case CustomerTypeEnum.IRA_TRADITIONAL:
                    eventBaseInfoType = 'traditional_ira';
                    break;
                case CustomerTypeEnum.IRA_ROLLOVER:
                    eventBaseInfoType = 'rollover_ira';
                    break;
                default:
                    break;
            }
        } else {
            if (!isEmptyValue(hasDeliveryAddress)) {
                eventBaseInfoType = hasDeliveryAddress ? 'us_mailing_address' : 'other_brokerage_certificates';
            }
        }
    }

    return eventBaseInfoType;
}
